import { Form, Button, Input } from "antd";
import { Row } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useQueryClient } from "react-query";
import toast from "react-hot-toast";
import "../../utils/style.css";
import FormField from "../../../../common/Form/FormField";
import SelectField from "../../../../common/Form/SelectField";
import { CreditCardOutlined } from "@ant-design/icons";
import { addBankAccount, updateBankAccount } from "../../services/bankApi";
import IBAN from "iban";
import { useState } from "react";
import { FormatErrorVersement } from "../../../../common/errorformat/errorFormat";
import { bankList } from "./bankListUemoa";
import { isValidUemoaAccount } from "./validUemoaIban";

const AddEditBankAccount = ({ selectedPaymentAccount = null, isEdit = false,onSuccessBank, onClose }) => {
  const queryClient = useQueryClient();
  const currentUser = JSON.parse(sessionStorage.getItem("authUser"));
  const merchantId = currentUser?.user?.id;
  const [error, setError] = useState(null);
  
  const initialValues = selectedPaymentAccount
    ? {
        name: selectedPaymentAccount.maskedName || "",
        nameBank: selectedPaymentAccount.nameBank || "",
        iban: selectedPaymentAccount.maskedIban || "",
        bicCode: selectedPaymentAccount.maskedBicCode || "",
        frequency: selectedPaymentAccount.frequency || "",
      }
    : {
        name: currentUser?.firstname + " " + currentUser?.lastname || "",
        nameBank: "",
        iban: "",
        bicCode: "",
        frequency: "",
      };
      // console.log('selectedPaymentAccount', selectedPaymentAccount)

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required("Nom du compte requis")
      .min(2, "Le nom du compte doit contenir au moins 2 caractères")
      .max(50, "Le nom du compte ne doit pas dépasser 50 caractères"),
    nameBank: Yup.string().required("Nom de la banque requis"),
    // iban: Yup.string().when([], {
    //   is: () => !selectedPaymentAccount?.maskedIban,
    //   then: (schema) =>
    //     schema
    //       .required("Numéro de compte requis")
    //       .test("is-valid-uemoa", function (value) {
    //         if (!value) return false;

    //         if (!isValidUemoaAccount(value)) {
    //           return this.createError({ message: "Numéro de compte UEMOA invalide" });
    //         }

    //         return true;
    //       }),
    //   otherwise: (schema) => schema.notRequired(),
    // }),
    // bicCode: Yup.string()
    //   .required("BIC / Swift requis")
    //   .matches(/^[A-Z0-9]{8,11}$/, "BIC/Swift invalide"),
    // frequency: Yup.string().required("Veuillez choisir la fréquence"),
  });

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values) => {
      const updatedData = {
        merchantId,
        name: values.name || "",
        nameBank: values.nameBank || "",
        bicCode: values.bicCode || "",
        frequency: values.frequency || "",
        token: currentUser?.token,
      };
      const data = selectedPaymentAccount
        ? updatedData
        : { ...updatedData, iban: values.iban.replace(/\s+/g, "") };

      try {
        if (selectedPaymentAccount) {
          await updateBankAccount(selectedPaymentAccount?.id, updatedData);
          toast.success("Compte modifié avec succès 🎉");
        } else {
          await addBankAccount(data);
          toast.success("Compte créé avec succès 🎉");
        }
        setError(null);
        await queryClient.invalidateQueries("accountsBanks");
        if (onSuccessBank) onSuccessBank();
        formik.resetForm();
        onClose();
      } catch (err) {
        const formatted = FormatErrorVersement(err?.response?.data);
        setError(formatted.message);        
        toast.error("Erreur d'enregistrement du compte");
      }
    },
  });

  const frequencyList = [
    { id: "MONDAY", label: "Lundi" },
    { id: "THURSDAY", label: "Jeudi" },
    { id: "BOTH", label: "Lundi et Jeudi" },
  ];

  const isFormValid = formik.isValid && Object.keys(formik.touched).length > 0;

  return (
    <div className="account-modal">
      <h5 className="text-center mb-4">
        Compte Bancaire <CreditCardOutlined />
      </h5>
      {selectedPaymentAccount && <h5 className="text-center mb-4">Modification compte</h5>}

      <Form layout="vertical" onFinish={formik.handleSubmit}>
        {error && <div className="alert alert-danger">{error}</div>}
        <Row>
          <FormField
            label="Nom du compte"
            name="name"
            formik={formik}
            colSize={6}
            type="text"
            style={{ height: "44px" }}
          />
          <SelectField
            label="Fréquence"
            name="frequency"
            formik={formik}
            options={frequencyList}
            error={formik.errors.frequency}
            colSize={6}
          />
          <SelectField
            disabled = {selectedPaymentAccount?.nameBank}
            label="Banque"
            name="nameBank"
            nameSelect=""
            formik={formik}
            options={bankList}
            error={formik.errors.nameBank}
            colSize={6}
            isNameShow={false}
            isName={false}
          />
          
          <FormField
            disabled = {selectedPaymentAccount?.maskedBicCode}
            label="BIC (ex : BNPAFRPP)"
            name="bicCode"
            formik={formik}
            colSize={6}
            type="text"
            maxLength={11}
            style={{ height: "44px" }}
            isUpperCase
          />

            <Form.Item
              label="IBAN ou N° de compte (ex: SN57...)"
              validateStatus={formik.errors.iban ? "error" : ""}
              help={formik.errors.iban}
            >
              <Input
                disabled = {selectedPaymentAccount?.maskedIban}
                maxLength={34}
                value={formik.values.iban}
                className="form-control pe-5"
                onChange={(e) => {
                  const rawValue = e.target.value.replace(/\s+/g, "").toUpperCase();
                  const formattedIban = rawValue.match(/.{1,4}/g)?.join(" ") || rawValue;
                  formik.setFieldValue("iban", formattedIban);
                }}
                onBlur={formik.handleBlur}
                style={{ width: "100%", height: "44px" }}
              />
            </Form.Item>
        </Row>
        <Button
          htmlType="submit"
          type="primary"
          loading={formik.isSubmitting}
          className="btn-confirm-reversement w-100 mt-4 mb-4"
          disabled={!isFormValid}
        >
          {selectedPaymentAccount ? "Modifier" : "Ajouter"}
        </Button>
      </Form>
    </div>
  );
};

export default AddEditBankAccount;